import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { AuthProvider } from './auth/AuthProvider'
import { AUTH_MODE } from './auth/config'
import { pca } from './auth/msal'
import { ThemeProvider } from '@/components/theme-provider'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Toaster } from '@/components/ui/sonner'
import { ErrorBoundary } from '@/components/ErrorScreen'
import './index.css'

async function bootstrap() {
    // In Entra mode, MSAL must be initialized and any redirect response
    // processed before the app renders.
    if (AUTH_MODE === 'entra' && pca) {
        await pca.initialize()
        await pca.handleRedirectPromise()
        const accounts = pca.getAllAccounts()
        if (accounts.length > 0) {
            pca.setActiveAccount(accounts[0])
        }
    }

    const rootEl = document.getElementById('root')!
    ReactDOM.createRoot(rootEl).render(
        <React.StrictMode>
            <ErrorBoundary>
            <ThemeProvider>
                <TooltipProvider delayDuration={200}>
                    <AuthProvider>
                        <RouterProvider router={router} />
                    </AuthProvider>
                    <Toaster richColors position="top-right" />
                </TooltipProvider>
            </ThemeProvider>
            </ErrorBoundary>
        </React.StrictMode>,
    )
}

void bootstrap()
